import React, { useState, useEffect } from "react";
import AdjustCustomerChargesGrid from "./adjust-customer-charges-grid-bm.component";
import "./adjustCustomerCharges.scss";
import AdjustCustomerChargesSearch from "./adjust-customer-charges-search-bm.component";
import ReviewCharge from "./adjust-customer-charges-review-charge-bm";
import AdjustCustomerChargesAlert from "./adjust-customer-charges-alert-bm.component";
import { FormState } from "./adjust-customer-charges-const";
import * as adjustCustomerChargesServices from "./adjust-customer-charges.services-bm";
import * as GlobalService from "../react/global_services";

interface Props {}

declare var window: any;
var $rootScope = window;
const wmsSelector = "AdustCustomerCharges";
const defaultFilterValue = {
    CustomerID: 0,
    CustomerName: null,
    FacilityID: null,
    ChargeType: null,
    category: null,
    RateName: null,
    IndexOptionsRateName: null,
};

const initialFormData = {
    rate: "",
    transactionType: "Adjustments",
    category: "",
    class: "",
    glAccountNumber: "",
    chargeLabel: "",
    chargeAmount: "",
    quantity: "",
    total: "",
    memoNote: "",
};

interface IChargePayload {
    CustomerIdentifier: { Id: number };
    FacilityIdentifier: { Id: number };
    PredefinedManualRateId?: string;
    TransactionType: string;
    Category: string;
    Class: string;
    GlAccount: string;
    ChargeLabel: string;
    ChargeAmount: string;
    Qty: string;
    Total: string;
    Memo: string;
}

const AdjustCustomerChargesHolder: React.FC<Props> = (props: Props): any => {
    const [windowId] = useState($rootScope.ChildBulletin.Data.Window);
    const [sharedFilterObject, setSharedFilterObject] = useState(defaultFilterValue);
    const [loadGrid, setLoadGrid] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedRow, setSelectedRow] = useState(undefined);
    const [selectedRowCount, setSelectedRowCount] = useState(0);
    const [formData, setFormData] = useState<FormState>(initialFormData);
    const [classOptions, setClassOptions] = useState([]);
    const [chargeCategoryOptions, setChargeCategoryOptions] = useState([]);
    const [isSearchClicked, setIsSearchClicked] = useState(false);
    const [optionsFacility, setFacilityOptions] = useState(GlobalService.getFacilityList(true));
    const [isCreateBillingManagerChargeLoading, setIsCreateBillingManagerChargeLoading] = useState(false);

    useEffect(() => {
        setLoadGrid(true);
        adjustCustomerChargesServices.getBillingCategoriesAndClasses().then((response) => {
            const classVar =
                response.data.Classes?.map((item) => {
                    return { id: item, name: item };
                }) || [];
            const chargeCategoryVar =
                response.data.Categories?.map((item) => {
                    return { id: item, name: item };
                }) || [];
            setClassOptions(classVar);
            setChargeCategoryOptions(chargeCategoryVar);
        });
    }, []);

    const resetChargeState = (resetFilter: boolean = false) => {
        setStep(1);
        setSelectedRow(undefined);
        setSelectedRowCount(0);
        setFormData(initialFormData);
        if (resetFilter) {
            setSharedFilterObject(defaultFilterValue);
        }
    };

    const onClearSearch = () => {
        resetChargeState(true);
    };

    const onHandleCreateAnotherCharge = () => {
        resetChargeState();
        setSharedFilterObject((previousState) => ({
            ...previousState,
            category: null,
            RateName: null,
            IndexOptionsRateName: null,
        }));
    };

    const onHandleNext = () => {
        const chargePayload: IChargePayload = {
            CustomerIdentifier: { Id: sharedFilterObject.CustomerID },
            FacilityIdentifier: { Id: sharedFilterObject.FacilityID },
            TransactionType: "Adjustments",
            Category: formData.category || undefined,
            Class: formData.class || undefined,
            GlAccount: formData.glAccountNumber || undefined,
            ChargeLabel: formData.chargeLabel || undefined,
            ChargeAmount: formData.chargeAmount || undefined,
            Qty: formData.quantity || undefined,
            Total: formData.total || undefined,
            Memo: formData.memoNote || undefined,
            PredefinedManualRateId: formData.predefinedRateId || undefined,
        };

        if (step === 3) {
            setIsCreateBillingManagerChargeLoading(true);
            adjustCustomerChargesServices
                .createBillingManagerCharge(chargePayload)
                .then(() => {
                    setStep(4);
                })
                .finally(() => {
                    setIsCreateBillingManagerChargeLoading(false);
                });
        } else {
            setStep((previousState) => (previousState >= 4 ? 4 : previousState + 1));
        }
    };

    const onHandleReturn = () => {
        setSelectedRow(undefined);
        setSelectedRowCount(0);
        setStep((previousState) => (previousState <= 1 ? 1 : previousState - 1));
    };

    return (
        <div className="adjust-customer-charges-wrapper flex-col-direction">
            {step !== 4 && (
                <AdjustCustomerChargesSearch
                    wmsSelector={wmsSelector}
                    sharedFilterObject={sharedFilterObject}
                    setSharedFilterObject={setSharedFilterObject}
                    onClearSearch={onClearSearch}
                    windowId={windowId}
                    onHandleNext={onHandleNext}
                    onHandleReturn={onHandleReturn}
                    step={step}
                    selectedRowCount={selectedRowCount}
                    formData={formData}
                    setFacilityOptions={setFacilityOptions}
                    optionsFacility={optionsFacility}
                    onChangeChargeType={onHandleCreateAnotherCharge}
                    isCreateBillingManagerChargeLoading={isCreateBillingManagerChargeLoading}
                />
            )}
            {sharedFilterObject.ChargeType === "isPredefinedRate" && step === 2 && loadGrid && (
                <AdjustCustomerChargesGrid
                    wmsSelector={wmsSelector}
                    windowId={windowId}
                    sharedFilterObject={sharedFilterObject}
                    setSharedFilterObject={setSharedFilterObject}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    setSelectedRowCount={setSelectedRowCount}
                    isSearchClicked={isSearchClicked}
                    setIsSearchClicked={setIsSearchClicked}
                    step={step}
                    optionsFacility={optionsFacility}
                    chargeCategoryOptions={chargeCategoryOptions}
                />
            )}
            {(step === 3 || (sharedFilterObject.ChargeType === "isManualCharge" && step === 2)) && (
                <ReviewCharge
                    wmsSelector={wmsSelector}
                    sharedFilterObject={sharedFilterObject}
                    formData={formData}
                    setFormData={setFormData}
                    step={step}
                    classOptions={classOptions}
                    chargeCategoryOptions={chargeCategoryOptions}
                    selectedRow={selectedRow}
                />
            )}
            {step === 4 && <AdjustCustomerChargesAlert onHandleCreateAnotherCharge={onHandleCreateAnotherCharge} />}
        </div>
    );
};
AdjustCustomerChargesHolder.propTypes = {};

export default React.memo(AdjustCustomerChargesHolder);
